import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { WebSocketProvider } from "@/context/WebSocketContext";
import { BrandProvider } from "@/context/BrandContext";

import Feed from "@/pages/Feed";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import Disciplines from "@/pages/Disciplines";
import ArtistProfile from "@/pages/ArtistProfile";
import PostDetail from "@/pages/PostDetail";
import Messages from "@/pages/Messages";
import Notifications from "@/pages/Notifications";
import Search from "@/pages/Search";
import Publish from "@/pages/Publish";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Live from "@/pages/Live";
import LiveRoom from "@/pages/LiveRoom";
import Rooms from "@/pages/Rooms";
import RoomDetail from "@/pages/RoomDetail";
import Marketplace from "@/pages/Marketplace";
import ProductDetail from "@/pages/ProductDetail";
import Studio from "@/pages/Studio";
import Calls from "@/pages/Calls";
import CallDetail from "@/pages/CallDetail";
import Collaborations from "@/pages/Collaborations";
import News from "@/pages/News";
import Settings from "@/pages/Settings";
import PressKit from "@/pages/PressKit";
import Admin from "@/pages/Admin";
import GlobalBanner from "@/components/GlobalBanner";
import { useAuth } from "@/context/AuthContext";

function Root() {
  const { user } = useAuth();
  // user: null = checking, false = guest, object = authed
  if (user === null) {
    return <div className="min-h-screen bg-[#050505]" />;
  }
  return user ? <Feed /> : <Landing />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrandProvider>
        <AuthProvider>
        <WebSocketProvider>
        <BrowserRouter>
        <ScrollToTop />
        <GlobalBanner />
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/bienvenida" element={<Landing />} />
          <Route path="/explorar" element={<Explore />} />
          <Route path="/disciplinas" element={<Disciplines />} />
          <Route path="/artista/:slug" element={<ArtistProfile />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/mensajes" element={<Messages />} />
          <Route path="/notificaciones" element={<Notifications />} />
          <Route path="/buscar" element={<Search />} />
          <Route path="/publicar" element={<Publish />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/ingresar" element={<Login />} />
          <Route path="/live" element={<Live />} />
          <Route path="/live/:id" element={<LiveRoom />} />
          <Route path="/salas" element={<Rooms />} />
          <Route path="/salas/:slug" element={<RoomDetail />} />
          <Route path="/tienda" element={<Marketplace />} />
          <Route path="/tienda/:id" element={<ProductDetail />} />
          <Route path="/estudio" element={<Studio />} />
          <Route path="/convocatorias" element={<Calls />} />
          <Route path="/convocatorias/:id" element={<CallDetail />} />
          <Route path="/colaboraciones" element={<Collaborations />} />
          <Route path="/boletin" element={<News />} />
          <Route path="/ajustes" element={<Settings />} />
          <Route path="/prensa/:slug" element={<PressKit />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        </BrowserRouter>
        </WebSocketProvider>
        </AuthProvider>
        </BrandProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
